import axios from 'axios'
import { SAVINGS_PLAN_ENDPOINT } from 'common/backend/endpoints'
import * as _ from 'lodash'

export async function getSavingsPlan(id) {
    const endpoint = `${SAVINGS_PLAN_ENDPOINT}/${id}`

    const { data } = await axios.get(endpoint)

    if (_.isEmpty(data)) return null

    const [bonification] = data.SavingsPlansBonifications
    delete data.SavingsPlansBonifications
    data.benefits = data.SavingsPlansBenefits
    data.SavingsPlansBenefits = data.SavingsPlansBenefits.map(e => e.name)
    data.SavingsPlansInstalmentsRanges = data.SavingsPlansInstalmentsRanges.sort((a, b) => a.from - b.from).map(
        (e, i, arr) => ({
            ...e,
            disabled: arr.length - 1 !== i
        })
    )
    data.SavingsPlansColors = data.SavingsPlansColors.map(c => ({ ...c, color: c.hexa_code}))

    if (data.financing_percentage) data.financing_percentage = (data.financing_percentage *= 100).toLocaleString()
    if (bonification?.subscription_quote_discount) bonification.subscription_quote_discount *= 100
    if (data.extraordinary_percentage) data.extraordinary_percentage = (data.extraordinary_percentage * 100).toFixed()
    if (data.aditional_percentage) data.aditional_percentage = String(+(data.aditional_percentage * 100).toFixed(1)).replace('.', ',')
    if (data.valid_to) data.valid_to = new Date(data.valid_to)

    return { ...data, bonification }
}
